import {extractListPayload} from './payload';

export const fetchAllPages = async (fetchPage, {firstPage = 1} = {}) => {
    const items = [];
    let page = firstPage;
    let total = 0;

    do {
        const result = extractListPayload(await fetchPage(page));
        if (!result.items.length) break;
        items.push(...result.items);
        total = result.total;
        page += 1;
    } while (items.length < total);

    return {data: {items, total: items.length}};
};
